module.exports = __webpack_public_path__ + "images/034203a232ac2ff8ae94c3dd49ca9d31.svg";